import { checkIsMobile } from '~/helpers/device.js';

export default function ({ req, store }) {
  const userAgent = req
    ? req.headers['user-agent']
    : navigator.userAgent || navigator.vendor || window.opera;
  const isMobile = checkIsMobile(userAgent);
  store.commit('deviceStore/setIsMobile', isMobile);
}
